import { createFileRoute, useParams } from "@tanstack/react-router";
import { AssetTypeLifecycleSection } from "@/utils/asset-type-detail/asset-type-lifecycle-section";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/lifecycle",
)({
	component: OrgAssetTypeLifecycleTab,
});

function OrgAssetTypeLifecycleTab() {
	const { orgId } = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/lifecycle",
	});

	return (
		<div className="px-5 pb-5">
			<AssetTypeLifecycleSection organizationId={orgId} variant="drawer" />
		</div>
	);
}
